
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './global.css';

// Register KARMA PWA service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .then((registration) => {
        console.log('KARMA service worker registered:', registration.scope);
      })
      .catch((error) => {
        console.error('KARMA service worker registration failed:', error);
      });
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
